class feedGlobalFlage {
  showFeedEntry = true;
}
const isShowFeed = new feedGlobalFlage();
export default isShowFeed;
